export default {
  facebook: 'https://www.facebook.com/chrisureza/',
  instagram: 'https://www.instagram.com/chrisureza/',
  linkedin: 'https://www.linkedin.com/in/chrisureza/',
  github: 'https://github.com/chrisureza',
}
